import { SelectListOption } from '@/core/models/select-list';
import { CustomFieldTypeName, CustomFieldTypeNames } from '@/crm-types/custom-fields/custom-fields-types';

/**
 * Determines the initial model value for a custom field.
 *
 * - Text fields always return empty string if no model exists
 * - Select fields only return default values when NOT in edit mode
 * - This prevents showing misleading default values when editing existing entities
 *
 * @param currentModel - The current model value
 * @param isEdit - Whether we're editing an existing entity
 * @param fieldType - The type of custom field (text, single, multi)
 * @param defaultValue - The default value option if one exists
 * @returns The initial model value to use
 */
export function getInitialCustomFieldModel(
    currentModel: Array<number> | number | string | null,
    isEdit: boolean,
    fieldType: CustomFieldTypeName,
    defaultValue?: SelectListOption
): Array<number> | number | string | null {
    // If model already has a value, keep it
    if (currentModel) {
        return currentModel;
    }

    // Text fields always initialize to empty string
    if (fieldType === CustomFieldTypeNames.TEXT) {
        return '';
    }

    // Select fields only get default values when adding new entities, not when editing
    if (!isEdit && defaultValue) {
        if (fieldType === CustomFieldTypeNames.MULTI) {
            return [defaultValue.value as number];
        }
        return defaultValue.value;
    }

    return null;
}
